module.exports = __webpack_public_path__ + "static/media/presentation_3.d3df7bab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/presentation_3.svg
// module id = 655
// module chunks = 1